/** Visual tokens for custom SVG dashboard charts */
export const CHART_FONT = '"Geist, sans-serif", system-ui, sans-serif';

export const CHART_THEME = {
  font: CHART_FONT,
  ink: "#0F1117",
  muted: "#5A6273",
  secondary: "#4A5162",
  grid: "#E8EEFB",
  surface: "#FFFFFF",
  tooltipBg: "rgba(15, 17, 23, 0.92)",
  tooltipFg: "#F8F8F6",
  radius: 8,
  barRadius: 6,
  markerR: 5,
  lineWidth: 2.75,
};

export const defaultMargins = {
  top: 16,
  right: 16,
  bottom: 72,
  left: 44,
};
